export const fontOptions = [
    // Sistem fontları
    { value: "Arial, sans-serif", label: "Arial" },
    { value: "Arial Black, sans-serif", label: "Arial Black" },
    { value: "Calibri, sans-serif", label: "Calibri" },
    { value: "Cambria, serif", label: "Cambria" },
    { value: "Candara, sans-serif", label: "Candara" },
    { value: "Comic Sans MS, cursive, sans-serif", label: "Comic Sans MS" },
    { value: "Courier New, monospace", label: "Courier New" },
    { value: "Georgia, serif", label: "Georgia" },
    { value: "Helvetica, sans-serif", label: "Helvetica" },
    { value: "Impact, sans-serif", label: "Impact" },
    { value: "Lucida Console, monospace", label: "Lucida Console" },
    { value: "Lucida Sans Unicode, sans-serif", label: "Lucida Sans Unicode" },
    { value: "Palatino Linotype, serif", label: "Palatino Linotype" },
    { value: "Segoe UI, sans-serif", label: "Segoe UI" },
    { value: "Tahoma, sans-serif", label: "Tahoma" },
    { value: "Times New Roman, serif", label: "Times New Roman" },
    { value: "Trebuchet MS, sans-serif", label: "Trebuchet MS" },
    { value: "Verdana, sans-serif", label: "Verdana" },
    { value: "Garamond, serif", label: "Garamond" },
    { value: "Gill Sans, sans-serif", label: "Gill Sans" },
    { value: "Franklin Gothic Medium, sans-serif", label: "Franklin Gothic Medium" },
    { value: "Century Gothic, sans-serif", label: "Century Gothic" },
    { value: "Bookman, serif", label: "Bookman" },
    { value: "Didot, serif", label: "Didot" },
    { value: "Optima, sans-serif", label: "Optima" },
    { value: "Perpetua, serif", label: "Perpetua" },
    { value: "Monaco, monospace", label: "Monaco" },
    { value: "Consolas, monospace", label: "Consolas" },

    // Kod yazımı için popüler monospace
    { value: "Fira Code, monospace", label: "Fira Code" },
    { value: "Source Code Pro, monospace", label: "Source Code Pro" },
    { value: "Inconsolata, monospace", label: "Inconsolata" },
    { value: "Ubuntu Mono, monospace", label: "Ubuntu Mono" },

    // Google Fonts - Sans Serif
    { value: "Roboto, sans-serif", label: "Roboto" },
    { value: "Open Sans, sans-serif", label: "Open Sans" },
    { value: "Poppins, sans-serif", label: "Poppins" },
    { value: "Montserrat, sans-serif", label: "Montserrat" },
    { value: "Lato, sans-serif", label: "Lato" },
    { value: "Raleway, sans-serif", label: "Raleway" },
    { value: "Nunito, sans-serif", label: "Nunito" },
    { value: "Josefin Sans, sans-serif", label: "Josefin Sans" },
    { value: "Quicksand, sans-serif", label: "Quicksand" },
    { value: "Oswald, sans-serif", label: "Oswald" },

    // Google Fonts - Serif
    { value: "Merriweather, serif", label: "Merriweather" },
    { value: "Playfair Display, serif", label: "Playfair Display" },
    { value: "Crimson Text, serif", label: "Crimson Text" },
    { value: "EB Garamond, serif", label: "EB Garamond" },

    // Google Fonts - Display / Eğlenceli
    { value: "Pacifico, cursive", label: "Pacifico" },
    { value: "Dancing Script, cursive", label: "Dancing Script" },
    { value: "Great Vibes, cursive", label: "Great Vibes" },
    { value: "Baloo 2, cursive", label: "Baloo 2" },
    { value: "Lobster, cursive", label: "Lobster" },
    { value: "Shadows Into Light, cursive", label: "Shadows Into Light" },
  ];